// ============================================================
// FILE: resources/js/plugins/theme.js
// USPATIH GO — Theme Manager (auto schedule + manual override)
// Dark: 18:00–06:00 waktu lokal browser pengguna
// ============================================================

import {
  THEME_STORAGE_KEY,
  THEME_AUTO_KEY,
  resolveTheme,
  isAutoThemeEnabled,
  getScheduledTheme,
  msUntilNextThemeChange,
} from '../helpers/themeSchedule.js';

const ThemeManager = {
  current: 'light',
  auto: true,
  _scheduleTimer: null,

  init() {
    this.auto = isAutoThemeEnabled();
    this.apply(resolveTheme());
    this.startAutoSchedule();
  },

  startAutoSchedule() {
    if (this._scheduleTimer) clearTimeout(this._scheduleTimer);

    const tick = () => {
      if (this.auto) {
        const scheduled = getScheduledTheme();
        if (scheduled !== this.current) {
          this.apply(scheduled);
          localStorage.setItem(THEME_STORAGE_KEY, scheduled);
          document.cookie = `theme=${scheduled}; path=/; max-age=31536000`;
        }
      }
      this._scheduleTimer = setTimeout(tick, msUntilNextThemeChange());
    };

    this._scheduleTimer = setTimeout(tick, msUntilNextThemeChange());
  },

  /**
   * Toggle: mode manual ↔ kembali ke jadwal otomatis
   */
  toggle() {
    if (this.auto) {
      this.auto = false;
      localStorage.setItem(THEME_AUTO_KEY, 'false');
      const manual = this.isDark() ? 'light' : 'dark';
      this.apply(manual);
      localStorage.setItem(THEME_STORAGE_KEY, manual);
    } else {
      this.auto = true;
      localStorage.setItem(THEME_AUTO_KEY, 'true');
      const scheduled = getScheduledTheme();
      this.apply(scheduled);
      localStorage.setItem(THEME_STORAGE_KEY, scheduled);
    }
    document.cookie = `theme=${this.current}; path=/; max-age=31536000`;
  },

  apply(theme) {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    this.current = theme;
  },

  isDark() {
    return document.documentElement.classList.contains('dark');
  },
};

ThemeManager.init();
window.ThemeManager = ThemeManager;

export default ThemeManager;
